import { DropDownBox, DropDownBoxLayoutStyle, DropDownBoxSearchMode } from '@apply/components';
import { useBrokerSearch } from '../queries/brokerQueries';

interface BrokerSearchFieldProps {
    value: number | undefined;
    onChange: (brokerId: number | undefined) => void;
    disabled: boolean;
}

/**
 * Searches brokers (optional). As in the old BrokerSelect, a chosen broker must be removed (see ClearBrokerButton)
 * before picking another.
 */
export const BrokerSearchField = ({ value, onChange, disabled }: BrokerSearchFieldProps) => {
    const dataSource = useBrokerSearch();
    // Disabled, or a broker is already chosen (it must be cleared first). Read-only as well as disabled, so the box
    // also gets DropDownBox's grey read-only background
    const cannotChange = disabled || !!value;

    return (
        <DropDownBox
            id='borrowerBrokerId'
            value={value ?? null}
            onChange={(id: number | null) => onChange(id ?? undefined)}
            label='Broker'
            dataSource={dataSource}
            displayExpr='displayName'
            valueExpr='id'
            placeholder={disabled ? 'None Selected' : 'Search Brokers...'}
            searchMode={DropDownBoxSearchMode.Contains}
            disabled={cannotChange}
            readOnly={cannotChange}
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
